import React, { memo } from 'react';
import cn from 'classnames';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import styles from './checksCommon.module.scss';
import style from './checksCart.module.scss';
import { TouchableButton, TouchableDiv } from '../common/Touchable/index';

const FullWithModal = React.lazy(() => import('../common/Modal/FullWidthModal'));

const TableConfirmationModal = ({
    isOpen,
    serverAppTheme,
    ConfirmationPopUpStyle,
    isOrderingPortrait,
    isTab,
    stationName,
    pendingActionType,
    seat,
    selectedSeats,
    addRemoveSeats,
    getGiftAndGameCard,
    sort,
    onClose,
    setConfirmPrint
}) => {
    return (
        <FullWithModal
            isOpen={isOpen}
            isModalCenter
            customClass2={cn("w-100 h-100")}
            noBackground
            style={ConfirmationPopUpStyle?.tablePopUp}
        >
            <div className='col-12 px-0 justify-content-center align-items-center position-relative text-center w-100 h-100' style={{ color: serverAppTheme?.primary_text }}>
                <div className={cn('col-12 px-2 d-flex', styles.moretitlebg, isOrderingPortrait ? 'py-1' : '')}>
                    <div className={cn('col-4 p-0 text-left', isOrderingPortrait ? 'fs_16' : 'fs_18')}>{isTab ? LABEL().TAB : LABEL().TABLE} : {stationName}</div>
                    <div className={cn('col-4 p-0 text-center')}>{pendingActionType?.type === 'print' ? LABEL().PRINT_RECEIPT_LABEL : LABEL().MOVE}</div>
                    <div className={cn('col-4 p-0 text-right', isOrderingPortrait ? 'fs_16' : 'fs_18')}>#{seat?.number}</div>
                </div>
                <div className={cn('pt-3 fw-600 text-center', isOrderingPortrait ? 'fs_18' : 'fs_16')}>{pendingActionType?.type === 'print' ? CUSTOM_MESSAGES().SELECT_SEAT_PRINT : CUSTOM_MESSAGES().SELECT_SEAT_MOVE}</div>
                <div className={cn("d-flex flex-column  fs_12 justify-content-start ", isOrderingPortrait ? 'h-76 mt-3' : 'h-70 mt-2')}
                    style={ConfirmationPopUpStyle?.moveStyle}
                >
                    <div className={cn("d-flex align-self-left row mx-0 mb-3", isOrderingPortrait ? 'w-50' : '')}>
                        <TouchableButton
                            role="presentation"
                            className={cn(selectedSeats.includes('table') ? style.selected_cartType : style.tabletilebackground, style.border_btn, 'rounded color-white px-3 py-1 text-center d-flex justify-content-center align-items-center', isOrderingPortrait ? 'fs_20' : 'fs_18')}
                            onClick={() => addRemoveSeats('table')}
                            style={ConfirmationPopUpStyle?.selectedSeatsStyle}
                            disabled={getGiftAndGameCard()}
                            rippleEffect={true}
                        >
                            {isTab ? LABEL().TAB : LABEL().TABLE}
                        </TouchableButton>
                    </div>
                    <div className={cn(isOrderingPortrait ? styles.gapPortrait : styles.gapLandscape, styles.wrapper, "overflowY align-items-center w-100")}>
                        {pendingActionType?.data?.seats && pendingActionType.data.seats.length > 0 && sort(pendingActionType.data.seats).map((e) => {
                            return e.open && (
                                <TouchableDiv
                                    key={e.id}
                                    role="presentation"
                                    className={cn('d-flex flex-column justify-content-center align-items-center btn-ripple rounded text-center fs_20 py-1 px-2', isOrderingPortrait ? 'fw-500' : 'fw-600')}
                                    onClick={() => addRemoveSeats(e.id)}
                                    style={ConfirmationPopUpStyle?.unSelectedSeatsStyle(e)}
                                    rippleEffect={true}
                                >
                                    <div>{e.number}</div>
                                    {e.name ? (
                                        <div className={styles.truncate}>
                                            {e.name}
                                        </div>
                                    ) : ''}
                                </TouchableDiv>
                            );
                        })}
                    </div>
                </div>
                <div className={cn('col-12 row mx-0 align-items-center justify-content-center text-center w-100 pt-3 pb-3', isOrderingPortrait ? 'position-absolute' : 'position-relative h-15')} style={ConfirmationPopUpStyle?.ActionBtnContainer}>
                    <div className={cn('col-6 pl-0 pr-1')}>
                        <TouchableButton className={cn("fw-600 col-12 px-0 fs_24", isOrderingPortrait ? 'btn68' : 'btn44')} type="button" onClick={(e) => { e.preventDefault(); onClose('no'); }}
                            style={ConfirmationPopUpStyle?.cancelButton}
                            rippleEffect={true}
                        >
                            {LABEL().CANCEL}
                        </TouchableButton>
                    </div>
                    {pendingActionType?.type === 'print' ? (
                        <div className={cn('col-6 pl-1 pr-0')}>
                            <TouchableButton className={cn("fw-600 col-12 px-0", isOrderingPortrait ? 'btn68' : 'btn44')} type="button"
                                onClick={() => {
                                    if (selectedSeats.length === 0) { setConfirmPrint(true) }
                                    else { onClose('yes', selectedSeats.includes('table') ? [] : selectedSeats); }
                                }}
                                style={ConfirmationPopUpStyle?.printButton}
                                rippleEffect={true}
                            >
                                {LABEL().PRINT}
                            </TouchableButton>
                        </div>
                    ) : (
                        <div className={cn('col-6 pl-1 pr-0')}>
                            <TouchableButton className={cn("fw-600 col-12 px-0 fs_24", isOrderingPortrait ? 'btn68' : 'btn44')} type="button" onClick={() => {
                                if (selectedSeats.length === 0) { setConfirmPrint(true) }
                                else { onClose('yes', selectedSeats.includes('table') ? [] : selectedSeats); }
                            }}
                                style={ConfirmationPopUpStyle?.printButton}
                                rippleEffect={true}
                            >
                                {(pendingActionType?.type === 'unsentRepeat' || pendingActionType?.type === 'sentRepeat') ? LABEL().REPEAT : LABEL().MOVE}
                            </TouchableButton>
                        </div>
                    )}
                </div>
            </div>
        </FullWithModal>
    );
};

export default memo(TableConfirmationModal);
